import type { ItemList, WithContext } from "schema-dts";
import { ORG, STRUCTURED_DATA_IDS } from "@/content/_site.config";
import type { Metadata } from "@/content/types";
import { getServiceItemOrCategories } from "../services";

export function buildItemListFromSpec(
  seo: Metadata,
): WithContext<ItemList> | null {
  if (!seo.itemList?.items.length) {
    return null;
  }

  const items = getServiceItemOrCategories(seo.itemList.items);

  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "@id": STRUCTURED_DATA_IDS.itemList(seo.canonical),
    url: `${ORG.url}${seo.canonical}`,
    name: seo.itemList.name,
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.label,
      url: `${ORG.url}${item.href}`,
    })),
  };
}
